import { oauthTokenSelector } from 'selectors/app/base'
import { doGraphqlRequest } from 'ducks/requests'
import navigateToLegacy from 'util/navigateToLegacy'
import { selectAccountSubdomain } from 'selectors/app'
import {
  basicFields,
  EXTENDED_BILLING_FIELDS,
  fetchBillingData,
  fetchInvoices,
  fetchBillingInformation,
  BILLING_INFORMATION_FIELDS,
  CREDIT_CARD_FIELDS,
} from '../api'
import {
  UPDATE_CARD,
  START_TRIAL,
  UPDATE_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION,
  FETCH_BILLING_DATA_REQUEST,
  FETCH_BILLING_DATA_SUCCESS,
  FETCH_BILLING_DATA_FAIL,
  FETCH_BILLING_INVOICES_REQUEST,
  FETCH_BILLING_INVOICES_SUCCESS,
  FETCH_BILLING_INVOICES_FAIL,
  FETCH_BILLING_INFORMATION_REQUEST,
  FETCH_BILLING_INFORMATION_SUCCESS,
  FETCH_BILLING_INFORMATION_FAILED,
  UPDATE_BILLING_INFORMATION,
  GET_INVOICE_PDF_LINKS,
  CLOSE_CARD_FAILURE_MODAL,
} from '../types'

export const doFetchBillingData = () => {
  return (dispatch, getState) => {
    const state = getState()
    const token = oauthTokenSelector(state)

    dispatch({ type: FETCH_BILLING_DATA_REQUEST })

    return fetchBillingData(token)
      .then(data => {
        dispatch({ type: FETCH_BILLING_DATA_SUCCESS, payload: data })
      })
      .catch(err => {
        dispatch({
          type: FETCH_BILLING_DATA_FAIL,
          payload: { error: err },
        })
      })
  }
}

export const doFetchInvoices = () => {
  return (dispatch, getState) => {
    const state = getState()
    const token = oauthTokenSelector(state)

    dispatch({ type: FETCH_BILLING_INVOICES_REQUEST })

    return fetchInvoices(token)
      .then(data => {
        dispatch({ type: FETCH_BILLING_INVOICES_SUCCESS, payload: { data } })
      })
      .catch(err => {
        dispatch({
          type: FETCH_BILLING_INVOICES_FAIL,
          payload: { error: err },
        })
      })
  }
}

export const doFetchBillingInformation = () => {
  return (dispatch, getState) => {
    const state = getState()
    const token = oauthTokenSelector(state)

    dispatch({ type: FETCH_BILLING_INFORMATION_REQUEST })

    return fetchBillingInformation(token)
      .then(data => {
        dispatch({ type: FETCH_BILLING_INFORMATION_SUCCESS, payload: { data } })
      })
      .catch(err => {
        dispatch({
          type: FETCH_BILLING_INFORMATION_FAILED,
          payload: { error: err },
        })
      })
  }
}

const cancelSubscriptionMutation = `
  mutation CancelSubscription($input: [CancellationReason!]!) {
    cancelSubscription(input: $input) {
      ${EXTENDED_BILLING_FIELDS}
    }
  }
`

export const doCancelSubscription = cancellationReasons => {
  return dispatch => {
    dispatch(
      doGraphqlRequest(CANCEL_SUBSCRIPTION, cancelSubscriptionMutation, {
        input: cancellationReasons,
      })
    )
  }
}

const updateSubscriptionMutation = `
  mutation UpdateSubscription(
    $inbox: String
    $kb: String
    $cycle: String!
    $convertTrials: Boolean!
    $legacy: Boolean!
  ) {
    updateSubscription(
      inbox: $inbox,
      kb: $kb,
      cycle: $cycle,
      convertTrials: $convertTrials,
      legacy: $legacy
    ) {
      ${EXTENDED_BILLING_FIELDS}
    }
  }
`

export const doUpdateSubscription = billing => {
  return dispatch => {
    const { inbox, kb, cycle } = billing

    dispatch(
      doGraphqlRequest(UPDATE_SUBSCRIPTION, updateSubscriptionMutation, {
        inbox: inbox === 'legacy' ? null : inbox,
        kb: kb !== 'none' ? kb : null,
        cycle,
        convertTrials: true,
        legacy: inbox === 'legacy',
      })
    )
  }
}

const startTrialMutation = `
  mutation StartTrial(
    $product: String!,
  ) {
    startTrial(
      product: $product
    ) {
      ${basicFields}
    }
  }
`

export function doStartTrial(product) {
  return dispatch => {
    const variables = { product }
    return dispatch(
      doGraphqlRequest(START_TRIAL, startTrialMutation, variables, {
        meta: { product },
        transformResponse: data => data.startTrial,
      })
    )
  }
}

export const doRedirectToLegacyBilling = () => (dispatch, getState) => {
  const state = getState()
  const subdomain = selectAccountSubdomain(state)
  const token = oauthTokenSelector(state)

  if (subdomain === undefined) return null

  return navigateToLegacy(token, subdomain, 'settings/billing')
}

const updateBillingInformationMutation = `
  mutation UpdateBillingInformation(
    $input: BillingInformationInput!
  ){
    updateBillingInformation(
      input: $input
    ) {
      ${BILLING_INFORMATION_FIELDS}
    }
  }
`

export const doUpdateBillingInformation = params => dispatch => {
  return dispatch(
    doGraphqlRequest(
      UPDATE_BILLING_INFORMATION,
      updateBillingInformationMutation,
      { input: params }
    )
  )
}

const updateCardMutation = `
  mutation ReplaceCreditCard(
    $token: String!
  ){
    replaceCard(
      token: $token
    ) {
      ${CREDIT_CARD_FIELDS}
    }
  }
`

export const doUpdateCard = stripeToken => dispatch => {
  return dispatch(
    doGraphqlRequest(UPDATE_CARD, updateCardMutation, { token: stripeToken.id })
  )
}

const getInvoicePdfLinksMutation = `
  mutation GetPdfLinksForInvoice(
    $invoiceId: String
  ) {
    getPdfLinksForInvoice(
      invoiceId: $invoiceId
    ) {
      invoicePdf
      receiptPdf
    }
  }
`

export const doGetInvoicePdfLinks = invoiceId => {
  return dispatch => {
    return dispatch(
      doGraphqlRequest(GET_INVOICE_PDF_LINKS, getInvoicePdfLinksMutation, {
        invoiceId,
      })
    )
  }
}

export const doCloseCardFailureError = () => dispatch => {
  return dispatch({
    type: CLOSE_CARD_FAILURE_MODAL,
  })
}
